import React, { Suspense } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';
import { Preloader } from '../Components/Preloader/Preloader';
import { Header } from '../Components/Header/Header';
import {Footer} from "../Components/Footer/Footer";
import ScrollToTop from '../Components/ScrollToTop';
import { SignIn } from './SignIn/SignIn';
import { SignUp } from './SignIn/SignUp';
import { Home } from './Home';
import { About } from './About';
import { Properties } from './Properties';
import { ContactUs } from './ContactUs';
import { Profile } from './Profile';
import { ApplicationDetails } from './Profile/ApplicationDetails';
import { BiddingPropertyDetails } from './Properties/BiddingPropertyDetails';
import { WithoutBiddingPropertyDetails } from './Properties/WithoutBiddingPropertyDetails';
import { PageNotFound } from '../Components/PageNotFound';

export const Layout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

    const location = useLocation();
    const isAuthPage =
       location.pathname === "/signup" || location.pathname==="/"||location.pathname==="*";

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
       <div>
         {!isAuthPage && <Header />}
         <main>
          <Suspense>
            <ScrollToTop/>
            <Routes>
                <Route path='/' element={<SignIn/>}/>
                <Route path="/signup" element={<SignUp/>}/>
              <Route path="/home" element={<Home/>}/>
              <Route path="/about" element={<About/>}/>
              <Route path="/properties" element={<Properties/>}/>
              <Route path="/bidding-property-details" element={<BiddingPropertyDetails/>}/>
              <Route path="/without-bidding-property" element={<WithoutBiddingPropertyDetails/>}/>
              <Route path="/contact" element={<ContactUs/>}/>
              <Route path="/profile" element={<Profile/>}/>
              <Route path="/application-details" element={<ApplicationDetails/>}/>
              <Route path="*" element={<PageNotFound/>}/>
              
             
            </Routes>
          </Suspense>
        </main>
       {!isAuthPage && <Footer />}
       </div>
      )}
    </>
  );
};
